import getLang from 'LearningCenterUI/utils/getLang';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error untyped import
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserAttribute } from '../../../features/userAttributes/userAttributesQueries';
import { UserAttributeKeys } from '../../../features/userAttributes';
import { create } from 'zustand';
import { useUserInfo } from '../../../features/accounts';
import Raven from 'raven-js';
const useAlertDismissed = create(set => ({
  alertDismissed: false,
  dismissAlert: () => set(() => ({
    alertDismissed: true
  }))
}));
export const useLanguageFilterLogic = () => {
  const [language, setLanguageFilter] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const filterLanguage = language.length ? language[0].toLowerCase() : null;
  const portalLanguage = getLang();
  const isEnglishPortal = portalLanguage === 'en';
  const {
    userInfo
  } = useUserInfo();
  const userId = userInfo ? userInfo.user.id : null;
  const {
    alertDismissed,
    dismissAlert
  } = useAlertDismissed();
  const dontApplyFilterAgain = useRef(false);
  const {
    userAttribute: dontShowAgain,
    setUserAttribute: setDontShowAgain,
    userAttributeLoading: userAttributesLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.DONT_SHOW_AGAIN);
  const {
    userAttribute: preappliedFilterChanged,
    setUserAttribute: setPreappliedFilterChanged,
    unsetUserAttribute: unsetPreappliedFilterChanged
  } = useUserAttribute(UserAttributeKeys.PREAPPLIED_FILTER_CHANGED);
  const userAttributesLoaded = !userAttributesLoading;
  useEffect(() => {
    if (!userAttributesLoaded || isEnglishPortal) {
      return;
    }
    if (!preappliedFilterChanged && !filterLanguage && !dontApplyFilterAgain.current) {
      dontApplyFilterAgain.current = true;
      setLanguageFilter(portalLanguage.toUpperCase());
      UsageTracker.track('filterInteraction', {
        action: 'default-language-filter-set',
        key: 'language',
        value: portalLanguage.toUpperCase()
      });
    } else if (!preappliedFilterChanged && filterLanguage !== portalLanguage) {
      dismissAlert();
      setDontShowAgain(true).catch(Raven.captureException.bind(Raven));
      setPreappliedFilterChanged(true).catch(Raven.captureException.bind(Raven));
      UsageTracker.track('filterInteraction', {
        action: 'default-language-filter-changed',
        key: 'language',
        value: filterLanguage ? filterLanguage.toUpperCase() : ''
      });
    } else if (preappliedFilterChanged && filterLanguage === portalLanguage) {
      unsetPreappliedFilterChanged().catch(Raven.captureException.bind(Raven));
      UsageTracker.track('filterInteraction', {
        action: 'default-language-filter-returned',
        key: 'language',
        value: filterLanguage.toUpperCase()
      });
      dontApplyFilterAgain.current = true;
    }
  }, [dismissAlert, filterLanguage, isEnglishPortal, portalLanguage, preappliedFilterChanged, setDontShowAgain, setLanguageFilter, setPreappliedFilterChanged, unsetPreappliedFilterChanged, userAttributesLoaded, userId]);
  const [dontShowAgainChecked, setDontShowAgainChecked] = useState(false);
  const handleDismissClick = useCallback(() => {
    dismissAlert();
    if (dontShowAgainChecked) {
      setDontShowAgain(true).catch(Raven.captureException.bind(Raven));
    }
  }, [dismissAlert, dontShowAgainChecked, setDontShowAgain]);
  return {
    filterLanguage: filterLanguage || 'en',
    portalLanguage,
    alertDismissed,
    dontShowAgain,
    userAttributesLoading,
    userAttributesError,
    dontShowAgainChecked,
    setDontShowAgainChecked,
    handleDismissClick
  };
};
export default useLanguageFilterLogic;